import React from 'react';
export function Footer() {
  return <footer className="bg-gradient-to-b from-[#fce7e9]/60 to-[#fdf2f4] py-12 px-6 text-center border-t border-[#f4b6c2]/30" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <h3 className="text-2xl font-serif font-bold text-[#6b4f3a] mb-3" data-id="element-95">
          MegaPack Pastelería Premium
        </h3>
        <p className="text-[#8b6f47] text-sm mb-8" data-id="element-96">
          Una academia pastelera premium para emprendedoras modernas.
        </p>
        <p className="text-xs text-[#8b6f47]/70" data-id="element-97">
          © 2026 MegaPack Pastelería Premium. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}